import { render, staticRenderFns } from "./accountEdit.vue?vue&type=template&id=36abeb7c"
import script from "./accountEdit.vue?vue&type=script&lang=js"
export * from "./accountEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports